module.exports = __webpack_public_path__ + "static/policy_book1_5-bdf4d429a1f41bd0ea1a08bb7f500466.png";